angular.module('common.directives.teethConverter', [])

    // teeth-converter directive
    .directive('teethConverter', function () {
        return {
            restrict: "AE",
            template: '{{teethRepresentation}}',
            scope: {
                data: '=',
                numberingScheme: '@'
            },
            controller: 'TeethConverterController',
            controllerAs: 'TeethConverterController'
        };
    })

    // Flags
    .constant('QUADRANT', {
        UpperJaw: 0,
        LowerJaw: 1,
        Jaw: 1,
        LeftSide: 0,
        RightSide: 2,
        Side: 2
    })

    // Scheme of the teeth map (types of the conversion)
    .constant('SCHEME', {
        FDIScheme: 'fdi',
        UniversalScheme: 'universal',
        PalmerScheme: 'palmer'
    })

    // Empty value of the teeth range
    .constant('EMPTY', '')

    // Teeth map factory
    .factory("teethMap", function TeethFactory(QUADRANT) {

        // Common Teeth Map without Key
        var teeth = [{FDI: "18", Palmer: "UR8", Universal: "1", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 1, MidlineOrdinalPosition : 8},
                     { FDI: "17", Palmer: "UR7", Universal: "2", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 2, MidlineOrdinalPosition: 7 },
                     { FDI: "16", Palmer: "UR6", Universal: "3", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 3, MidlineOrdinalPosition: 6 },
                     { FDI: "15", Palmer: "UR5", Universal: "4", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 4, MidlineOrdinalPosition: 5 },
                     { FDI: "14", Palmer: "UR4", Universal: "5", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 5, MidlineOrdinalPosition: 4 },
                     { FDI: "13", Palmer: "UR3", Universal: "6", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 6, MidlineOrdinalPosition: 3 },
                     { FDI: "12", Palmer: "UR2", Universal: "7", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 7, MidlineOrdinalPosition: 2 },
                     { FDI: "11", Palmer: "UR1", Universal: "8", Quadrant: QUADRANT.UpperJaw | QUADRANT.RightSide, OrdinalPosition: 8, MidlineOrdinalPosition: 1 },
                     { FDI: "21", Palmer: "UL1", Universal: "9", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 9, MidlineOrdinalPosition: 9 },
                     { FDI: "22", Palmer: "UL2", Universal: "10", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 10, MidlineOrdinalPosition: 10 },
                     { FDI: "23", Palmer: "UL3", Universal: "11", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 11, MidlineOrdinalPosition: 11 },
                     { FDI: "24", Palmer: "UL4", Universal: "12", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 12, MidlineOrdinalPosition: 12 },
                     { FDI: "25", Palmer: "UL5", Universal: "13", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 13, MidlineOrdinalPosition: 13 },
                     { FDI: "26", Palmer: "UL6", Universal: "14", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 14, MidlineOrdinalPosition: 14 },
                     { FDI: "27", Palmer: "UL7", Universal: "15", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 15, MidlineOrdinalPosition: 15 },
                     { FDI: "28", Palmer: "UL8", Universal: "16", Quadrant: QUADRANT.UpperJaw | QUADRANT.LeftSide, OrdinalPosition: 16, MidlineOrdinalPosition: 16 },
                     { FDI: "38", Palmer: "LL8", Universal: "17", Quadrant: QUADRANT.LowerJaw | QUADRANT.LeftSide, OrdinalPosition: 17, MidlineOrdinalPosition: 24 },
                     { FDI: "37", Palmer: "LL7", Universal: "18", Quadrant: QUADRANT.LowerJaw | QUADRANT.LeftSide, OrdinalPosition: 18, MidlineOrdinalPosition: 23 },
                     { FDI: "36", Palmer: "LL6", Universal: "19", Quadrant: QUADRANT.LowerJaw | QUADRANT.LeftSide, OrdinalPosition: 19, MidlineOrdinalPosition: 22 },
                     { FDI: "35", Palmer: "LL5", Universal: "20", Quadrant: QUADRANT.LowerJaw | QUADRANT.LeftSide, OrdinalPosition: 20, MidlineOrdinalPosition: 21 },
                     { FDI: "34", Palmer: "LL4", Universal: "21", Quadrant: QUADRANT.LowerJaw | QUADRANT.LeftSide, OrdinalPosition: 21, MidlineOrdinalPosition: 20 },
                     { FDI: "33", Palmer: "LL3", Universal: "22", Quadrant: QUADRANT.LowerJaw | QUADRANT.LeftSide, OrdinalPosition: 22, MidlineOrdinalPosition: 19 },
                     { FDI: "32", Palmer: "LL2", Universal: "23", Quadrant: QUADRANT.LowerJaw | QUADRANT.LeftSide, OrdinalPosition: 23, MidlineOrdinalPosition: 18 },
                     { FDI: "31", Palmer: "LL1", Universal: "24", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 24, MidlineOrdinalPosition: 17 },
                     { FDI: "41", Palmer: "LR1", Universal: "25", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 25, MidlineOrdinalPosition: 25 },
                     { FDI: "42", Palmer: "LR2", Universal: "26", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 26, MidlineOrdinalPosition: 26 },
                     { FDI: "43", Palmer: "LR3", Universal: "27", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 27, MidlineOrdinalPosition: 27 },
                     { FDI: "44", Palmer: "LR4", Universal: "28", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 28, MidlineOrdinalPosition: 28 },
                     { FDI: "45", Palmer: "LR5", Universal: "29", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 29, MidlineOrdinalPosition: 29 },
                     { FDI: "46", Palmer: "LR6", Universal: "30", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 30, MidlineOrdinalPosition: 30 },
                     { FDI: "47", Palmer: "LR7", Universal: "31", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 31, MidlineOrdinalPosition: 31 },
                     { FDI: "48", Palmer: "LR8", Universal: "32", Quadrant: QUADRANT.LowerJaw | QUADRANT.RightSide, OrdinalPosition: 32, MidlineOrdinalPosition: 32 }
        ];

        // Prepare map with FDI key
        var map = {};

        _.forEach(teeth, function (tooth) {
            map[tooth.FDI] = tooth;
        });

        return map;
    })

    .controller('TeethConverterController', function ($scope, gettext, teethMap, QUADRANT, SCHEME, EMPTY, uiLocalization) {

        initData();

        $scope.$watch('data', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                initData();
            }
        });

        function initData() {
            // If teeth is null then return.
            if (_.isNull($scope.data) || _.isUndefined($scope.data) ||
                _.isNull($scope.data.teeth) || _.isUndefined($scope.data.teeth) ||
                _.isNull($scope.data.teeth.tooth) || _.isUndefined($scope.data.teeth.tooth)) {
                // no value
                $scope.teethRepresentation = EMPTY;
                return;
            }

            // -------------------------------------
            // Functions.
            // -------------------------------------

            // Declare helper function
            var getToothLabel = function (tooth, scheme) {
                switch (scheme) {
                    case SCHEME.UniversalScheme:
                        return tooth.Universal;
                    case SCHEME.PalmerScheme:
                        return tooth.Palmer;
                    default:
                        return tooth.FDI;
                }
            };

            // Get number of the elements
            var getNumElements = function (data) {
                if (_.isNull(data.numelements) || _.isUndefined(data.numelements)) {
                    return null;
                } else {
                    var result = parseInt(data.numelements);
                    return _.isNaN(result) ? null : result;
                }
            };

            // Get location (it depends on format of JSON data which was passed into controller)
            var getLocation = function (location) {
                // Standard JSON which was retrieved from xml2json function (now we get it from the test)
                if (location._ !== undefined) {
                    return location._;
                }
                // JSON from OM server
                if (location['#text'] !== undefined) {
                    return location['#text'];
                }
                return null;
            };

            // -------------------------------------

            // Use toJSON function of Kendo API to get js array if it necessary
            var teeth = _.isUndefined($scope.data.teeth.tooth.toJSON)
                ? $scope.data.teeth.tooth
                : $scope.data.teeth.tooth.toJSON();

            // Teeth array for iterating
            var teethList = $.isArray(teeth) ? teeth : [teeth];

            // The empty list of the mapped teeth
            var valueList = [];

            // Use the TeethMap to turn tooth numbers read from the XML data
            // into real teeth. We use the ordinal members of the TeethMap
            // to decide on how to sort the collection after we've converted it.
            _.forEach(teethList, function (tooth) {

                if (!_.isNull(tooth.location) && !_.isUndefined(tooth.location)) {

                    // Map tooth to the TeethMap (if no tooth then return null)
                    var mappedTooth = teethMap[getLocation(tooth.location)];

                    if (!_.isUndefined(mappedTooth)) {
                        valueList.push(mappedTooth);
                    }
                }
            });

            // -------------------------------------
            // If there are no teeth to show, use the numelements node to simply show the number of elements.
            // -------------------------------------

            if (valueList.length === 0) {

                var numelements = getNumElements($scope.data);

                // no value
                if (_.isNull(numelements)) {
                    $scope.teethRepresentation = EMPTY;
                } else {
                    //Marking the string for translation to be picked up via 'gettext' call
                    $scope.teethRepresentation = uiLocalization.translate(gettext("%s unit"), numelements);
                }
                return;
            }

            // -------------------------------------

            // Teeth scheme
            var toothNumberingScheme = $scope.numberingScheme.toLowerCase();

            // Determine the kind of sorting
            var sortbyMidlineOrdinal = toothNumberingScheme !== SCHEME.UniversalScheme;

            // If all the teeth are not in the same quadrant of the mouth, sort by the ordinal position
            // rather than the midline position - this ensures we don't end up with a range like
            // 11-22 for a 5 unit bridge spanning teeth 11,12,13,21,22 in the FDI numbering scheme
            var firstToothQuadrant = _.first(valueList).Quadrant;

            if (_.any(valueList, function (tooth) {
                    return tooth.Quadrant != firstToothQuadrant;
                })) {
                sortbyMidlineOrdinal = false;
            }

            // Do sorting
            valueList = _.sortBy(valueList, function (tooth) {
                return sortbyMidlineOrdinal ? tooth.MidlineOrdinalPosition : tooth.OrdinalPosition;
            });

            // This code assumes that if we have a bridge restoration that the teeth specified
            // are consecutive. We assume that the data entry system (ie DentCAD has validated this).
            var first = _.first(valueList);
            var last = _.last(valueList);

            if (first.FDI === last.FDI) {
                $scope.teethRepresentation = getToothLabel(first, toothNumberingScheme);
            } else {
                //Marking the string for translation to be picked up via 'gettext' call
                $scope.teethRepresentation = uiLocalization.translate(gettext("%s unit, %s"),
                    valueList.length,
                    _.str.sprintf('%s - %s', getToothLabel(first, toothNumberingScheme), getToothLabel(last, toothNumberingScheme)));
            }
        }

    });
